<template>
    <div class="container-fluid">
        <b-card no-body class="card-transparent-background my-2">
            <b-card-header class="p-0">
                <b-row>
                    <b-col md="6"> <b-card-title class="card-title-page-garden-help-default my-1">Contractor Profile
                        </b-card-title></b-col>
                    <!-- <b-col md="6">
                        <b-button variant="garden-help-info-light" class="btn-bumblebee btn-garden-help float-end">
                            <font-awesome-icon icon="fa-solid fa-pen" /> Edit</b-button>
                    </b-col> -->
                </b-row>

            </b-card-header>
        </b-card>


        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm">
            <div v-if="contractor != null">

                <b-row>
                    <b-col xl="8" lg="9" md="9">
                        <b-card class="profile-details-card-garden-help" body-class="px-0">
                            <div class="avatar-profile d-flex align-items-center">
                                <b-avatar class="avatar-garden-help avatar-garden-help-light  d-flex align-items-center"
                                    size="80px"></b-avatar>
                                <h3 class="ml-3 mb-0">{{ contractor ? contractor.name : '' }}
                                    <span
                                        v-if="contractor && (contractor.city || contractor.county || contractor.country)"><img
                                            src="@/assets/images/garden-help/location-icon.png" width="20px" />
                                        <span v-if="contractor && contractor.city" class="d-inline-block"> {{contractor ? contractor.city : '' }}</span><span
                                            v-if="contractor && contractor.county" class="d-inline-block">, {{ contractor ? contractor.county : '' }}</span><span v-if="contractor && contractor.country" class="d-inline-block">,
                                            {{ contractor ? contractor.country : ''}}</span></span>
                                    <span>{{ contractor ? contractor.email : '' }}</span>
                                    <span>{{ contractor ? contractor.phone : '' }}</span>
                                </h3>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col xl="4" lg="3" md="6" class="py-3">
                        <b-card class="profile-data-card-garden-help h-100 my-0 text-center" body-class="align-self-center">
                            <b-card-title>{{ contractor.completed_jobs_count }}</b-card-title>
                            <b-card-text>Total jobs</b-card-text>
                        </b-card>
                    </b-col>
                </b-row>


                <b-row>
                    <b-col xl="5" lg="5" md="6">
                        <div id="contractor-data-col">
                            <!--work details-->
                            <b-card class="profile-details-card-garden-help" no-body>
                                <b-card-header class=""><b-card-title class="card-title-garden-help">
                                        Work details
                                    </b-card-title></b-card-header>
                                <b-card-body class="p-0">
                                    <b-card no-body class="card-transparent-background my-0 pt-0">
                                        <b-card-body class="p-0">
                                            <div class="container mx-0">
                                                <b-row>
                                                    <b-col sm="12">
                                                        <b-form-group
                                                            class="form-group-garden-help form-group-no-border d-flex"
                                                            label="Experience Level" label-for="experience_level"
                                                            label-class="form-label-garden-help" label-cols-xl="4"
                                                            content-cols-xl="8" label-cols-lg="5" content-cols-lg="7"
                                                            label-cols-md="5" content-cols-md="7" label-cols="6"
                                                            content-cols="6">

                                                            <span id="experience_level"
                                                                class="form-control form-control-garden-help">
                                                                {{ contractor.experience_level }}
                                                            </span>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col sm="12">
                                                        <b-form-group
                                                            class="form-group-garden-help form-group-no-border d-flex"
                                                            label="Rate" label-for="rate"
                                                            label-class="form-label-garden-help" label-cols-xl="4"
                                                            content-cols-xl="8" label-cols-lg="5" content-cols-lg="7"
                                                            label-cols-md="5" content-cols-md="7" label-cols="6"
                                                            content-cols="6">

                                                            <span id="rate" class="form-control form-control-garden-help">
                                                                {{ contractor.rate_type }}
                                                            </span>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col sm="12">
                                                        <b-form-group
                                                            class="form-group-garden-help form-group-no-border d-flex"
                                                            label="Rate Amount" label-for="rate_amount"
                                                            label-class="form-label-garden-help" label-cols-xl="4"
                                                            content-cols-xl="8" label-cols-lg="5" content-cols-lg="7"
                                                            label-cols-md="5" content-cols-md="7" label-cols="6"
                                                            content-cols="6">
                                                            <span id="rate_amount"
                                                                class="form-control form-control-garden-help">
                                                                {{ contractor.rate_amount }} EUR
                                                            </span>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </b-card-body>
                                    </b-card>
                                </b-card-body>
                            </b-card>

                            <!--services-->
                            <b-card class="profile-details-card-garden-help" no-body>
                                <b-card-header class=""><b-card-title class="card-title-garden-help">
                                        Skills
                                    </b-card-title></b-card-header>
                                <b-card-body class="pt-0 px-1">
                                    <b-row cols-xl="2" cols-lg="1" cols-md="2" cols="1" class="mx-0">
                                        <b-col class="my-1" v-for="(service, index) in contractor.services_str"
                                            :key="index">
                                            <div class="tags"> {{ service }}</div>
                                        </b-col>
                                    </b-row>
                                </b-card-body>
                            </b-card>
                            <!--social media-->
                            <b-card v-if="contractor.linkedin || contractor.facebook || contractor.website"
                                class="profile-details-card-garden-help" no-body>
                                <b-card-header class=""><b-card-title class="card-title-garden-help">
                                        Social Media
                                    </b-card-title></b-card-header>
                                <b-card-body class="pt-0 px-1">
                                    <router-link v-if="contractor.linkedin != null && contractor.linkedin != ''"
                                        :to="contractor.linkedin" target="_blank">
                                        <img src="@/assets/images/garden-help/linkedin-icon.png"
                                            class="social-media-icon" />
                                    </router-link>
                                    <router-link v-if="contractor.facebook != null && contractor.facebook != ''"
                                        :to="contractor.facebook" target="_blank">
                                        <img src="@/assets/images/garden-help/facebook-icon.png"
                                            class="social-media-icon" />
                                    </router-link>
                                    <router-link v-if="contractor.website != null && contractor.website != ''"
                                        :to="contractor.website" target="_blank">
                                        <img src="@/assets/images/garden-help/website-icon.png" class="social-media-icon" />
                                    </router-link>
                                </b-card-body>
                            </b-card>
                        </div>
                    </b-col>
                    <!--jobs list-->
                    <b-col xl="7" lg="7" md="6" class="py-3" id="contractor-jobs-col">
                        <b-card class="profile-details-card-garden-help h-100 my-0" no-body>
                            <b-card-header class="pb-0">
                                <b-card-title class="card-title-garden-help">
                                    Work history
                                </b-card-title>
                            </b-card-header>
                            <b-card-body class="pt-0 px-1">
                                <b-list-group class="list-group-jobs" v-if="contractor.completed_jobs.length > 0">
                                    <b-list-group-item class="flex-column align-items-start"
                                        v-for="(job, index) in contractor.completed_jobs" :key="index">
                                        <div class="d-flex w-100 justify-content-between">
                                            <h5 class="mb-1">{{ getServicesNamesFromObject(job.services, false) }}</h5>
                                            <!-- <span>€50.00</span> -->
                                        </div>
                                        <p class="mb-1">
                                            Initiated {{ job.details.booking_date_web }}
                                        </p>
                                    </b-list-group-item>
                                </b-list-group>
                                <b-list-group class="list-group-jobs" v-else>
                                    <b-list-group-item class="flex-column align-items-start no-border">
                                        <p class="text-center">No data found</p>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-card-body>
                        </b-card>


                    </b-col>
                </b-row>



                <b-card class="profile-details-card-garden-help" no-body 
                    v-if="contractor.media.filter((v) => v.media_type == 'company_image').length > 0">
                    <b-card-header class=""><b-card-title class="card-title-garden-help">
                            Images </b-card-title></b-card-header>
                    <b-card-body class="">
                        <VueSlickCarousel v-bind="settings" class="slick-slider-garden-help">
                            <div v-for="item in contractor.media.filter(
                                (v) => v.media_type == 'company_image'
                            )" :key="item.id" class="">
                                <div> <img :src="item.path" class="m-auto" />
                                </div>
                            </div>
                        </VueSlickCarousel>
                    </b-card-body>
                </b-card>
            </div>
        </b-overlay>

    </div>
</template>


<script>
import axios from "axios";
import $ from "jquery";
import PersonalInfo from "../profile_details_components/PersonalInfo.vue";
import CompanyDetails from "../profile_details_components/CompanyDetails.vue";
import WorkInfo from "../profile_details_components/WorkInfo.vue";
import SocialMediaInfo from "../profile_details_components/SocialMediaInfo.vue";

import { getServicesNamesFromObject } from "@/utils/helper-functions-garden-help.js"

export default {
    name: "GardenHelpPublicContractorProfile",
    components: { PersonalInfo, CompanyDetails, WorkInfo, SocialMediaInfo },
    data() {
        return {
            show_overlay: true,
            client_name: "GARDENHELP",
            user_type: localStorage.getItem('user_type'),
            user_id: null, // logined user


            settings: {
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 4,
                swipeToSlide: true,
                responsive: [
                    //col-xl-2 col-lg-3 col-md-3 col-6
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            },

            contractor: null,
           
        }
    },
    mounted() {
        // let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = Number(this.$route.params.id); Number(this.$route.params.id);

        // this.getFilterData()

        this.getContractorData()

        this.resizeScreen()
        let temp = this
        window.addEventListener("resize", () => {
            setTimeout(() => {
                temp.resizeScreen()
            });
        });
        //
    },
    methods: {
        getServicesNamesFromObject,
        getContractorData() {
            console.log("in get contractor data", this.user_type, this.user_id)
            this.show_overlay = true

            axios
                .get("/operator/contractor/profile/" + this.user_id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)
                    this.contractor = response.data;

                    let services_str = [], services_id = []

                    for (let i = 0; i < response.data.services.length; i++) {
                        let service = response.data.services[i]
                        services_str.push(service.name)
                        services_id.push(service.id)
                    }

                    this.contractor.services_str = services_str
                    this.contractor.services_id = services_id

                    this.resizeScreen()
                    this.show_overlay = false

                });
        },

        resizeScreen() {
            // console.log(window.innerWidth, window.outerWidth)
            if (window.innerWidth > 576) {
                // console.log($('#contractor-data-col'))
                let height = $('#contractor-data-col').height()
                // console.log(height)
                // console.log($("#contractor-jobs-col .card-body .list-group-jobs"))
                $("#contractor-jobs-col .card-body .list-group-jobs").css("max-height", (height - 80) + 'px')
            }
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profiles_views/PublicProfile.vue